// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { getRedirectUrl, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { useRedirect } from '@tectonics/hooks';
import { Link } from '../../../atoms';

export function OtpRedirectPage(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const redirectUrl = getRedirectUrl(incomingPayment);
  useRedirect(redirectUrl, 8000);

  return (
    <Root data-test-id="page-pending-payment">
      <p>You are being redirected to the payment instructions in a few seconds, if this does not work, <Link href={redirectUrl}>click here</Link>.</p>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2em;
  margin: 0 32px 0 32px;
`;
